/**
 * Avatar Loader Utility
 * 
 * Utility function để load avatar theo pattern chuẩn:
 * 1. Lấy avatar từ data (user.avatar hoặc mappedData.avatar)
 * 2. Build full URL bằng buildFullUrl()
 * 3. Thử fetch và convert sang data URI bằng fetchImageAsDataUri()
 * 4. Nếu thành công, dùng data URI
 * 5. Nếu thất bại, fallback về URL trực tiếp
 * 6. Nếu không có avatar, return null
 */

import { buildFullUrl, fetchImageAsDataUri } from '../contexts/AvatarContext';

/**
 * Load avatar từ avatar string (relative URL hoặc full URL)
 * @param avatar - Avatar string từ user data (có thể là relative URL hoặc full URL)
 * @returns Promise<string | null> - Data URI nếu thành công, URL trực tiếp nếu fetch thất bại, hoặc null nếu không có avatar
 */
export const loadAvatarFromData = async (avatar: string | null | undefined): Promise<string | null> => {
  if (!avatar) {
    return null;
  }

  // Build full URL từ avatar string
  const fullUrl = buildFullUrl(avatar);
  if (!fullUrl) {
    return null;
  }

  // Thử fetch và convert sang data URI
  const dataUri = await fetchImageAsDataUri(fullUrl);
  if (dataUri) {
    return dataUri;
  }

  // Fallback: dùng URL trực tiếp nếu fetch data URI thất bại
  return fullUrl;
};
